import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initAuthTimers } from "./utils/authFetch"; // держит авторизацию

initAuthTimers(); // ⬅️ запускаем ДО render()

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
